import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, IUtilsDictionary, LoggingService, UtilsJson, UtilsMisc, UtilsString } from '@pit/core';
import { EntityDataService } from '@pit/core-data';
import { IDtoResource, DtoResource, ResourceState } from '@pit/frontend-model';
import { map, Observable } from 'rxjs';
import { IDtoResourceEntityDataService } from '../interfaces/dto.resource.entity.data.service.interface';

@Injectable({
    providedIn: 'root'
})
export class DtoResourceEntityDataService extends EntityDataService<IDtoResource> implements IDtoResourceEntityDataService {

    constructor(http: HttpClient, configService: ConfigService, loggingService: LoggingService) {
        super(http, null, configService, loggingService);
    }

    public getResourcesForMandatorByDepotNumber$(mandator: string, depotNumber: string): Observable<IDtoResource[]> {
        return this.httpGet(`/api/web/resource/mandator/${mandator}/depot/${depotNumber}`)
            .pipe(map((entities: IDtoResource[]) => {
                const result: IDtoResource[] = [];
                if ((UtilsMisc.isNullOrUndefined(entities) === false) && (entities.length > 0)) {
                    for (const entity of entities) {
                        result.push(this.createEntityFromJson(entity));
                    }
                }
                return result;
            }));
    }

    public async getResourcesForMandatorByDepotNumberAsync(mandator: string, depotNumber: string): Promise<IDtoResource[]> {
        return (await this.getResourcesForMandatorByDepotNumber$(mandator, depotNumber).toPromise());
    }

    public resetFaults$(mandator: string, resourceId: string): Observable<IDtoResource> {
        return this.httpPost(`/api/web/resource/reset/faults/mandator/${mandator}/resource/${resourceId}`, null)
            .pipe(map((json: IDtoResource) => {
                let result: IDtoResource = null;
                if (UtilsMisc.isNullOrUndefined(json) === false) {
                    result = this.createEntityFromJson(json);
                }
                return result;
            }));
    }

    public async resetFaultsAsync(mandator: string, resourceId: string): Promise<IDtoResource> {
        return (await this.resetFaults$(mandator, resourceId).toPromise());
    }

    public resetUserCurrent$(mandator: string, resourceId: string): Observable<IDtoResource> {
        return this.httpPost(`/api/web/resource/reset/usercurrent/mandator/${mandator}/resource/${resourceId}`, null)
            .pipe(map((json: IDtoResource) => {
                let result: IDtoResource = null;
                if (UtilsMisc.isNullOrUndefined(json) === false) {
                    result = this.createEntityFromJson(json);
                }
                return result;
            }));
    }

    public async resetUserCurrentAsync(mandator: string, resourceId: string): Promise<IDtoResource> {
        return (await this.resetUserCurrent$(mandator, resourceId).toPromise());
    }

    public setResourceState$(mandator: string, resourceId: string, state: ResourceState): Observable<IDtoResource> {
        return this.httpPost(`/api/web/resource/mandator/${mandator}/resource/${resourceId}/state/${state.toString()}`, null)
            .pipe(map((json: IDtoResource) => {
                let result: IDtoResource = null;
                if (UtilsMisc.isNullOrUndefined(json) === false) {
                    result = this.createEntityFromJson(json);
                }
                return result;
            }));
    }

    public async setResourceStateAsync(mandator: string, resourceId: string, state: ResourceState): Promise<IDtoResource> {
        return (await this.setResourceState$(mandator, resourceId, state).toPromise());
    }

    protected override doGetApiUrl(): string {
        return '/api/web/resource';
    }

    protected override createEntityFromJson(json: any): IDtoResource {
        const result: IDtoResource = (UtilsJson.deserialize(json, DtoResource) as IDtoResource);
        if (result !== null) {
            result.setReferences();
        }

        return result;
    }

}
